import { Component, Input } from '@angular/core';

@Component({
    selector: 'card-stats',
    templateUrl: './card-stats.component.html',
    styleUrl: './card-stats.component.scss',
    standalone: false
})
export class CardStatsComponent {
  @Input() card?: { value: unknown; label: string; color?: string };
  @Input() valueDescription?: string;
}
